import { ProColumns } from "@ant-design/pro-table";
import { DateRangeWithDisabled } from "@components/Common";
import React from "react";

const options = [{label: 'options1', value: 1}, {label: 'options2', value: 2}]


/**
 * 列表表格配置:
 *  自定义表格 CustomerDemo 和 antd 升级版组件 ProTableDemo 都可使用, 
 * */
export const columnsFn: (operate: Function) => ProColumns<any>[] = (operate) => {
    return [
        {
            title: '用户姓名',
            dataIndex: 'name',
        },
        {
            title: '身份证号',
            dataIndex: 'idCard',
        },
        {
            title: '验证结果',
            dataIndex: 'adCheckType',
            render: (text: any, record: any) => record.adCheckTypeStr,
            hideInSearch: true
        },
        {
            title: '备注',
            dataIndex: 'remark',
            hideInSearch: true
        },
        {
            title: '调用时间',
            dataIndex: 'callTime',
            // valueType: 'dateTimeRange',
            valueType: 'dateRange',
            fieldProps: { },
            width: 200,
            search: {
                transform: (value) => {
                    return {
                        startTime: value[0] ? value[0] + ' 00:00:00' : undefined,
                        endTime: value[1] ? value[1] + ' 23:59:59' : undefined
                    }
                },
            },
            renderFormItem: (props) => <DateRangeWithDisabled />,
            render: (text: any, record: any) => record.callTime,
        },
        {
            title: '是否计费',
            dataIndex: 'feeStr',
            width: 100,
            hideInSearch: true
        },
    ]
}
